import { lazy } from 'react';

const UPSClaimForm = lazy(() => import('./UPSClaimForm'));
const USPSClaimForm = lazy(() => import('./USPSClaimForm'));

export { UPSClaimForm, USPSClaimForm };
